import * as getters from './getters'
import * as actions from './actions'
import * as mutations from './mutations'

import manifest from './manifest'
import profile from './profile'
import filters from './filters'

const state = {
  currentUser: null,
  destinyMemberships: null,
  currentDestinyMembership: null,
  loading: false
}

const store = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    filters,
    manifest,
    profile
  }
}

export default store



// WEBPACK FOOTER //
// ./src/store/destiny/index.js